import Home from './Home';
import PageRtcMsgLog from './dev/PageRtcMsgLog';
import PageAbout from './settings/PageAbout';
import PagePrivacySetting from './settings/PagePrivacySetting';
import PageBlockSetting from './settings/PageBlockSetting';
import PageInquiry from './settings/PageInquiry';
import PageNotification from './notification/PageNotification';
import PageUnderAgeComplete from './underage/PageUnderAgeComplete';
import PageUnderAgeDocument from './underage/PageUnderAgeDocument';
import PageUnderAgeForm from './underage/PageUnderAgeForm';
import PageUnderAgePicturePreview from './underage/PageUnderAgePicturePreview';
import PageUnderAgeVerification from './underage/PageUnderAgeVerification';
import PageUnderAgeYotiPrepare from './underage/PageUnderAgeYotiPrepare';
import PageUnderAgeYotiVerify from './underage/PageUnderAgeYotiVerify';

const PAGES = [
  { path: '/', element: Home },
  { path: Def.PAGE_ABOUT, element: PageAbout },
  { path: Def.PAGE_PRIVACYSETTINGS, element: PagePrivacySetting },
  { path: Def.PAGE_BLOCKLIST, element: PageBlockSetting },
  { path: '/dev/rtc-msg-log', element: PageRtcMsgLog },
  { path: Def.PAGE_INQUIRY, element: PageInquiry },
  { path: Def.PAGE_NOTIFICATION, element: PageNotification },
  // Underage
  { path: Def.PAGE_UNDERAGE_DOCUMENT, element: PageUnderAgeDocument },
  { path: Def.PAGE_UNDERAGE_FORM, element: PageUnderAgeForm },
  { path: Def.PAGE_UNDERAGE_VERIFICATION, element: PageUnderAgeVerification },
  { path: Def.PAGE_UNDERAGE_PICTURE_PREVIEW, element: PageUnderAgePicturePreview },
  { path: Def.PAGE_UNDERAGE_COMPLETE, element: PageUnderAgeComplete },
  { path: Def.PAGE_UNDERAGE_YOTI_PREPARE, element: PageUnderAgeYotiPrepare },
  { path: Def.PAGE_UNDERAGE_YOTI_VERIFY, element: PageUnderAgeYotiVerify },
];

export default PAGES;
